import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { routes } from 'core/routes/paths'
import { MenuItem } from './item'
import giftIcon from './assets/images/gift.svg'
import finallyIcon from './assets/images/finally.svg'
import chatIcon from './assets/images/chat.svg'
import questionIcon from './assets/images/question.svg'
import c from './assets/sass/menu.module.scss'

const LANGUAGES = [
    { code: 'ru', flag: 'RU', label: 'Русский' },
    { code: 'en', flag: 'EN', label: 'English' },
    { code: 'ua', flag: 'UA', label: 'Українська' },
    { code: 'es', flag: 'SP', label: 'Español' },
    { code: 'pt', flag: 'BR', label: 'Português' },
    { code: 'pl', flag: 'PL', label: 'Polski' },
    { code: 'tr', flag: 'TR', label: 'Türkçe' },
    { code: 'ro', flag: 'RO', label: 'Română' },
    { code: 'uz', flag: 'UZ', label: "O'zbek" },
]

export const ProfileMenu = () => {
    const { t, i18n } = useTranslation()
    const navigate = useNavigate()
    const [showLangs, setShowLangs] = useState(false)

    const currentLang = i18n.language || 'ru'
    const currentFlag = LANGUAGES.find(l => l.code === currentLang)?.flag || currentLang.toUpperCase()

    const handleLangChange = (code) => {
        i18n.changeLanguage(code)
        localStorage.setItem('i18nextLng', code)
        localStorage.setItem('languageSource', 'manual')
        setShowLangs(false)
    }

    const handleSupport = () => {
        const url = 'https://t.me/ggturbo_support_bot?start=start'
        try {
            if (window?.Telegram?.WebApp?.openTelegramLink) {
                window.Telegram.WebApp.openTelegramLink(url)
            } else {
                window.open(url, '_blank')
            }
        } catch (e) {
            window.open(url, '_blank')
        }
    }

    return (
        <div className={c.component}>
            <MenuItem
                icon={giftIcon}
                label={t('profileMenu.rewardHistory')}
                onClick={() => navigate(routes.history)}
            />
            <MenuItem
                icon={finallyIcon}
                label={t('profileMenu.changeLanguage')}
                onClick={() => setShowLangs(!showLangs)}
                rightContent={
                    <span className={c.langBadge}>
                        <img src={`/images/Type=${currentFlag}.png`} alt="" className={c.langFlag} />
                        {currentLang.toUpperCase()}
                    </span>
                }
            />
            {showLangs && (
                <div className={c.langGrid}>
                    {LANGUAGES.map(lang => (
                        <button
                            key={lang.code}
                            className={`${c.langItem} ${lang.code === currentLang ? c.langActive : ''}`}
                            onClick={() => handleLangChange(lang.code)}
                        >
                            <img src={`/images/Type=${lang.flag}.png`} alt="" className={c.langFlag} />
                            <span>{lang.label}</span>
                        </button>
                    ))}
                </div>
            )}
            <MenuItem
                icon={chatIcon}
                label={t('profileMenu.support')}
                onClick={handleSupport}
                rightContent={<span className={c.chatBtn}>{t('profileMenu.startChat')}</span>}
            />
            <MenuItem
                icon={questionIcon}
                label={t('profileMenu.faq')}
                onClick={() => navigate(routes.faq)}
            />
        </div>
    )
}
